import {merge} from "lodash-es";
import {getEntityTypeIcon} from "utils/icons";
import {objectMap} from "utils/misc";
import {sentenceCase} from "utils/stringUtils";
import {EDGE_STYLE_COMMON} from "./graphStyleConstants";

/**
 * Format data from API into format required by Store.
 * Add labels and icons to nodes & edges
 *
 * - items: Node & Edge map
 * - groups: Groups included in dataset.
 * - entityTypes: List entity types included in dataset.
 *
 * @param {Object<Object, Object, Object>} param0 Node, Edge & Group map objects.
 * @returns {Object}
 */
export const formatGraphData = ({nodes, edges, groups}) => ({
  items: {...formatNodes(nodes), ...formatEdges(edges)},
  groups: groups
});

const formatNodes = (nodes) =>
  objectMap(nodes, (node) =>
    merge(node, {
      fontIcon: {
        text: `ph-${getEntityTypeIcon(node.data.type)}`
      },
      label: {
        text: `${node.label.text}`
      }
    })
  );

/**
 * Note on Label Text:
 * The backend attached label text in the correct format `label:{text:'...'}`.
 * However, since we've moved to only showing edge labels on hover, we re-assign the
 * default label text to a custom property 'labelText'.
 * The 'onItemInteraction' callback will handle temporarily taking the value of
 * 'labelText' and assigning it to the actual label:text property.
 */
const formatEdges = (edges) =>
  objectMap(edges, (edge) =>
    merge(edge, EDGE_STYLE_COMMON, {
      labelText: sentenceCase(edge.label.text),
      label: {
        text: ""
      }
    })
  );
